<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div class="name-container">
      <span>{{ title }}</span>
      <input class="btn btn-default cst-btn" type="submit" value="Save Changes" (click)="saveChanges()" />
      <input class="btn btn-default cst-btn" type="submit" value="Go Back" (click)="goBack()" />
    </div>
    <div class="details">
      <div class="heading">
        <span class="sub-heading">IVR PROMPTS DETAILS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container field-Container">
        <div class="form-group ivr-detail-field">
          <label for="IVRName">Name</label>
          <input type="text" class="form-control inp" id="IVRName" placeholder="Name" [value]="IVRDetail?.Name" />
        </div>

        <div class="form-group ivr-detail-field">
          <label for="ivrDescription">Description</label>
          <input
            type="text"
            class="form-control inp"
            id="ivrDescription"
            placeholder="Description"
            [value]="IVRDetail?.Description"
            [(ngModel)]="description"
          />
        </div>

        <div class="form-group ivr-detail-field">
          <label class="search-label" for="channeldropdown">Channel</label>

          <!-- <input type="text" [readonly]="true" class="form-control" class='inp' id="agentName" placeholder="-"
                    [value]="IVRDetail.Type"> -->
          <!-- <select id="channeldropdown" class="inp" *ngIf="channelTypes.length > 0"
                        [(ngModel)]="IVRDetail.Type">
                        <ng-container *ngFor="let item of channelTypes">
                            <option [ngValue]="item">{{item.label}}</option>
                        </ng-container>
                    </select> -->

          <!-- <select name="page" class="audit-dropdown" 
                                        >
                                     
                                            <option [ngValue]="IVRDetail?.Channel">
                                              {{ IVRDetail.Channel }}
                                              </option>
                                       

                                    </select> -->

          <select id="channeldropdown" class="inp" [value]="IVRDetail?.Channel" disabled="true">
            <ng-container *ngFor="let item of channels">
              <option [ngValue]="item.label" [defaultSelected]="IVRDetail?.Channel == item.label">
                {{ item.label }}
              </option>
            </ng-container>
          </select>
        </div>

        <div class="form-group ivr-detail-field">
          <label class="search-label" for="channelTypedropdown">Prompt Type</label>

          <select id="channeldropdown" class="inp" [value]="IVRDetail?.Type" disabled="true">
            <ng-container *ngFor="let item of PromptType">
              <option [ngValue]="item.label">{{ item.label }}</option>
            </ng-container>
          </select>
          <!-- <select name="page" class="audit-dropdown" 
          >
       
              <option [ngValue]="IVRDetail?.Type">
                {{ IVRDetail.Type }}
                </option>
         

      </select> -->

          <!-- <select id="channelTypedropdown" class="inp" *ngIf="channels.length > 0"
                        [(ngModel)]="IVRDetail.Channel">
                        <ng-container *ngFor="let item of channels">
                            <option [ngValue]="item">{{item.label}}</option>
                        </ng-container>
                    </select> -->
        </div>
      </div>

      <div class="row crud-container field-Container">
        <div class="form-group ivr-detail-field">
          <label for="createdOn">Created</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="createdOn"
            placeholder="Created On"
            [value]="IVRDetail?.Created | custdate"
          />
        </div>

        <div class="form-group ivr-detail-field">
          <label for="status">Last Updated</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="status"
            placeholder="Status"
            [value]="IVRDetail?.LastUpdated | custdate"
          />
        </div>

        <div class="form-group ivr-detail-field" *ngIf="IVRDetail?.Type == 'API'">
          <label class="search-label" for="channelTypedropdown">API Method</label>
          <br />

          <select id="channeldropdown" class="inp" disabled="true">
            <ng-container *ngFor="let item of APIMethodTypes">
              <option [ngValue]="IVRDetail?.ApiMethod" [defaultSelected]="IVRDetail?.Type == item.label">
                {{ item.label }}
              </option>
            </ng-container>
          </select>
          <!-- <select name="page" class="audit-dropdown" 
          >
       
              <option [ngValue]="IVRDetail?.ApiMethod">
                {{ IVRDetail.ApiMethod}}
                </option>
         

      </select> -->
          <!-- <select id="channelTypedropdown" class="inp" *ngIf="channels.length > 0"
                        [(ngModel)]="IVRDetail.ApiMethod">
                        <ng-container *ngFor="let item of channels">
                            <option [ngValue]="item">{{item.label}}</option>
                        </ng-container>
                    </select> -->
        </div>
      </div>
    </div>

    <!------------ Section 2 ---------->
    <div class="details">
      <div class="heading">
        <span class="sub-heading">MESSAGES</span>
        <hr class="solid-divider" />
      </div>

      <div class="crud-container" style="display: grid">
        <label class="block-title-1">Text To Speech</label>
        <label class="block-title-2">Enter the text in the message fields.</label>
      </div>
      <div class="container message-container">
        <div>
          <div class="message-div" style="margin-right: 0.5rem">
            <label class="inp-txtmessage" for="promtMessage">Prompt Message:</label>
            <div class="box">
              <textarea
                style="padding-left: 0"
                class="form-controltxt msg-textarea"
                id="promtMessage"
                placeholder="Enter your Message"
                [value]="IVRDetail?.Message"
                [(ngModel)]="recordedfilesToSaveMessage"
              ></textarea>

              <!-- <input
                type="text"
                [readonly]="true"
                class="form-control inp"
                id="promtMessage"
                placeholder="Enter Your Message"
                [value]="IVRDetail?.Message"

                
              /> -->
              <!-- <div  *ngIf="this.MessagepromtChange.value === 'Prompt Message'"> -->
              <!-- <span class="audio-timer" *ngIf="!isRecording && !blobUrl"> {{ recordedTime }} </span>
              <div class="audio-timer" *ngIf="savingRecordingFileMessage">{{ savingRecordingFileMessage }}</div> -->
              <!-- <div
              [ngClass]="{ loadingDotAnimation: savingAudioFileMessage === 'Saving File' }"
              class="audio-timer fs-hint"
              >
                {{ savingAudioFileMessage }}
              </div> -->
            </div>
          </div>
          <div class="row preview-div">
            <input
              class="btn btn-default preview-btn"
              type="submit"
              value="Preview"
              (click)="previewMessage()"
              *ngIf="isPreviewEnable"
              [disabled]="
                (recordedfilesToSaveMessage.length === 0 && IVRDetail?.Message.length === 0) ||
                activeButton === 'ivrPreview'
              "
            />
            <input
              class="btn btn-default preview-btnCancel"
              type="submit"
              value="Cancel"
              (click)="cancelPreviewMessage()"
              *ngIf="!isPreviewEnable"
              [disabled]="recordedfilesToSaveMessage.length === 0 && IVRDetail?.Message.length === 0"
            />
          </div>
        </div>
        <div style="width: 10rem"></div>
        <div>
          <div class="message-div" style="margin-left: 0.5rem">
            <label class="inp-txtmessage" for="failureMessage">Failure Message:</label>
            <div class="box">
              <textarea
                style="padding-left: 0"
                class="form-controltxt msg-textarea"
                id="failureMessage"
                placeholder="Enter your Message"
                [value]="IVRDetail?.FailureMessage"
                [(ngModel)]="saveFailureMessage"
              >
              </textarea>
            </div>
          </div>
          <div class="row preview-div">
            <input
              class="btn btn-default preview-btn"
              type="submit"
              value="Preview"
              (click)="previewMessageIVRPrompts()"
              *ngIf="isFailurePreviewEnable"
              [disabled]="
                (saveFailureMessage.length === 0 && IVRDetail?.FailureMessage.length === 0) ||
                activeButton === 'preview'
              "
            />
            <input
              class="btn btn-default preview-btnCancel"
              type="submit"
              value="Cancel"
              (click)="cancelPreviewMessageIVRPrompts()"
              *ngIf="!isFailurePreviewEnable"
              [disabled]="saveFailureMessage.length === 0 && IVRDetail?.FailureMessage.length === 0"
            />
          </div>
        </div>
      </div>

      <div class="row mt-1r" style="display: grid">
        <label class="block-title-1">Upload File or Real Time Recording</label>
        <label class="block-title-2"
          >If you have a .wav file to upload or would like a real-time recording please choose a message</label
        >

        <div class="row crud-container">
          <div style="padding-left: 0.8rem">
            <div style="display: flex">
              <div class="form-group ivr-detail-field">
                <label class="search-label" for="messageSource">Message Source</label>
                <!-- <select id="messageSource" class="inp" *ngIf="channels.length > 0"
                                    [(ngModel)]="IVRDetail.Channel">
                                    <ng-container *ngFor="let item of channels">
                                        <option [ngValue]="item">{{item.label}}</option>
                                    </ng-container>
                                </select> -->
                <select
                  name="messagetype"
                  class="inp"
                  [(ngModel)]="selectedMessageSource.value"
                  (change)="onMessageSourceChange()"
                >
                  <option label="Select one:" value="-1" selected></option>
                  <option [value]="msg.value" *ngFor="let msg of messageSource">{{ msg.label }}</option>
                </select>
              </div>

              <!-- <div class="form-group inp-txt">
                              <input class="form-control file-upload" type="file" id="formFile">
                          </div> -->
              <div class="form-group choose-file" *ngIf="this.selectedMessageSource.value === 'uploadfile'">
                <input
                  class="form-control file-upload"
                  accept=".mp3,audio/*"
                  type="file"
                  id="formFile"
                  (change)="handleFileInput($event)"
                />
                <!-- <div
                      [ngClass]="{ loadingDotAnimation: savingAudioFileMessage === 'Saving File' }"
                      class="audio-timer fs-hint"
                    >
                      {{ savingAudioFileMessage }}
                    </div> -->
              </div>
              <div class="form-group col padl-0 record-div" *ngIf="this.selectedMessageSource.value === 'recording'">
                <button class="btn btn-danger btn-cancel record-btn" *ngIf="isRecording" (click)="startRecording()">
                  <img src="{{ baseHref }}/assets/images/icon-mic.png" class="btn-img" /><span class="btn-text">
                    Record</span
                  >
                </button>
                <button *ngIf="!isRecording" class="btn btn-danger btn-cancel record-btn" (click)="stopRecording()">
                  <img src="{{ baseHref }}/assets/images/icon-stop.png" class="btn-img" /><span class="btn-text">
                    Stop</span
                  >
                </button>

                <!-- <span class="audio-timer" *ngIf="!isRecording && !blobUrl"> {{ recordedTime }} </span>
                    <div class="audio-timer" *ngIf="savingRecordingFileMessage">{{ savingRecordingFileMessage }}</div>
                  </div> -->
              </div>
            </div>
            <div class="row">
              <label class="block-title-2 msg-lbl">Please upload only .wav file format</label>
            </div>

            <div class="row crud-container-toaudio" style="padding-left: 0.8rem">
              <div class="form-group ivr-detail-field">
                <label class="search-label" for="MessagepromtChange">Append Audio To</label>
                <select
                  id="AppendAudioType"
                  class="inp"
                  [(ngModel)]="MessagepromtChange.value"
                  (change)="onMessagepromtChange()"
                >
                  <ng-container *ngFor="let item of AppendAudioType">
                    <option [ngValue]="item.value">{{ item.label }}</option>
                  </ng-container>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->

    <!------------ Section 3 ---------->
    <div class="details">
      <div class="heading">
        <span class="sub-heading">RESPONSES</span>
        <hr class="solid-divider" />
      </div>

      <div class="row crud-container" style="padding-left: 0.8rem">
        <div class="form-group ivr-detail-field col" *ngIf="IVRDetail?.IVRPrompts.length >= 1">
          <label for="promtMessage"></label>

          <label for="promtMessage"></label
          ><input
            class="form-check-input"
            *ngIf="IVRDetail?.Type == 'Switch'"
            type="checkbox"
            value=""
            id="flexCheckChecked"
          />

          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="promtMessage"
            placeholder="Enter Your Message"
            [value]="IVRDetail?.IVRPrompts[0].Name"
          />
        </div>

        <div class="form-group ivr-detail-field col">
          <label class="search-label" for="messageSource">Event Type</label>
          <select id="messageSource" class="inp" disabled="true">
            <ng-container *ngFor="let item of Eventtype">
              <option [ngValue]="item">{{ item.label }}</option>
            </ng-container>
          </select>
        </div>

        <div class="form-group ivr-detail-field col">
          <label for="requestType">Request Type</label>
          <input type="text" [readonly]="true" class="form-control inp" id="requestType" />
        </div>

        <div class="form-group ivr-detail-field col">
          <label for="priority">Priority</label>
          <input type="text" [readonly]="true" class="form-control inp" id="priority" />
        </div>

        <div class="form-group ivr-detail-field col">
          <label for="color">Color</label>
          <input type="text" [readonly]="true" class="form-control inp" id="color" />
        </div>
      </div>
      <div class="row crud-container" style="padding-left: 0.8rem" *ngIf="IVRDetail?.Type == 'Switch'">
        <div class="form-group ivr-detail-field col">
          <label for="promtMessage"></label
          ><input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="promtMessage"
            placeholder="Enter Your Message"
            [value]="iVRDetailForName?.IVRPrompts[1].Name"
          />
        </div>

        <!-- <div class="col read-only-txt">
          <label for="promtMessage">(Ask) BCN TW - Welcome</label>
        </div> -->

        <div class="form-group ivr-detail-field col">
          <label class="search-label" for="messageSource">Event Type</label>
          <select id="messageSource" class="inp" disabled="true">
            <ng-container *ngFor="let item of Eventtype">
              <option [ngValue]="item">{{ item.label }}</option>
            </ng-container>
          </select>
        </div>

        <div class="form-group ivr-detail-field col">
          <label for="requestType">Request Type</label>
          <input type="text" [readonly]="true" class="form-control inp" id="requestType" />
        </div>

        <div class="form-group ivr-detail-field col">
          <label for="priority">Priority</label>
          <input type="text" [readonly]="true" class="form-control inp" id="priority" />
        </div>

        <div class="form-group ivr-detail-field col">
          <label for="color">Color</label>
          <input type="text" [readonly]="true" class="form-control inp" id="color" />
        </div>
      </div>

      <div class="row crud-container" style="padding-left: 0.8rem" *ngIf="IVRDetail?.Type == 'API'">
        <div class="form-group ivr-detail-field">
          <label class="search-label" for="playMessage">Failure Prompt Type</label>
          <select id="channeldropdown" class="inp" (change)="onOptionsSelected($event)">
            <ng-container>
              <option *ngFor="let key of IVRPromptFailureTypes | keyvalue" [value]="key.value">{{ key.key }}</option>
              <!-- <ng-container *ngFor="let item of IVRPromptFailureTypes" ></ng-container> -->
              <!-- <option [ngValue]="item">{{ key.key}}</option> -->
              <!-- <option [ngValue]="item">{{ item.label }}</option> -->
            </ng-container>
          </select>
          <!-- <select id="playMessage" class="inp" *ngIf="channels.length > 0" [(ngModel)]="IVRDetail.Type">
                        <ng-container *ngFor="let item of channels">
                            <option [ngValue]="item">{{item.label}}</option>
                        </ng-container>
                    </select> -->
        </div>

        <div class="form-group ivr-detail-field">
          <label class="search-label" for="actionKey">Failure Prompt</label>
          <select id="channeldropdown" class="inp">
            <ng-container *ngFor="let item of IVRPromptFailureByTypes">
              <option [ngValue]="item.label">{{ item.label }}</option>
            </ng-container>
          </select>
          <!-- <select id="actionKey" class="inp" *ngIf="channels.length > 0" [(ngModel)]="IVRDetail.Channel">
                        <ng-container *ngFor="let item of channels">
                            <option [ngValue]="item">{{item.label}}</option>
                        </ng-container>
                    </select>
                </div> -->
        </div>
      </div>

      <!------------ Section 4 ---------->
      <div class="details" style="margin-bottom: 5rem">
        <div class="heading">
          <span class="sub-heading">RELATED INBOUND QUEUES</span>
          <hr class="solid-divider" />
        </div>

        <div
          *ngIf="IVRPromptQueues && IVRPromptQueues.length > 0"
          class="row crud-container"
          style="border: 0.063rem solid #2e308e; background: #ffffff 0% 0% no-repeat padding-box; padding: 1rem 0"
        >
          <div class="form-group col">
            <label style="font-size: 0.875rem; letter-spacing: 0rem; color: #000048"></label>
            <input
              type="text"
              class="form-control inp"
              id="ivrDescription"
              placeholder="IVRPromptQueues"
              [value]="IVRPromptQueues?.[0].Name"
            />
          </div>
          <div class="col-2">
            <input
              class="btn btn-outline-primary edit-btn"
              type="submit"
              value="Edit"
              (click)="saveChangesEdit(IVRPromptQueues?.[0].ID)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
